import { FlexTrigger } from '@/data/data-models';

// n.b. new triggers also need to be added to the FlexEventGroup class in data-models.js
// new triggers also need to be added to trigger-mappings.js
export const triggerNames = {
    CLICK: 'click',
    MOUSEENTER: 'mouseenter',
    MOUSELEAVE: 'mouseleave',
    SUBMIT: 'submit',
    VIEW: 'view',
    LOAD: 'load',
    COLLECTION_LOAD: 'collectionLoad',
    FLEX_EVENT: 'flexEvent',
    CHANGE: 'change',
};

export default new Map([
    [triggerNames.CLICK, new FlexTrigger({
        name: triggerNames.CLICK,
        label: 'On Click',
        icon: 'mouse',
        iconSet: 'fas',
        component: 'trigger-click',
    })],

    [triggerNames.MOUSEENTER, new FlexTrigger({
        name: triggerNames.MOUSEENTER,
        label: 'On Mouse Over',
        icon: 'mouse-pointer',
        iconSet: 'fas',
    })],

    [triggerNames.MOUSELEAVE, new FlexTrigger({
        name: triggerNames.MOUSELEAVE,
        label: 'On Mouse Away',
        icon: 'mouse-pointer',
        iconSet: 'fad',
    })],

    [triggerNames.SUBMIT, new FlexTrigger({
        name: triggerNames.SUBMIT,
        label: 'On Form Submit',
        icon: 'envelope-open-text',
        iconSet: 'fas',
        component: 'trigger-form-submit',
    })],

    [triggerNames.VIEW, new FlexTrigger({
        name: triggerNames.VIEW,
        label: 'On View',
        icon: 'binoculars',
        iconSet: 'fas',
        component: 'trigger-view',
    })],

    [triggerNames.LOAD, new FlexTrigger({
        name: triggerNames.LOAD,
        label: 'On Page Load',
        icon: 'file',
        iconSet: 'fas',
    })],

    [triggerNames.COLLECTION_LOAD, new FlexTrigger({
        name: triggerNames.COLLECTION_LOAD,
        label: 'On Collection Load',
        icon: 'database',
        iconSet: 'fas',
        component: 'trigger-collection-load',
    })],

    [triggerNames.FLEX_EVENT, new FlexTrigger({
        name: triggerNames.FLEX_EVENT,
        label: 'On Event',
        icon: 'fire',
        iconSet: 'fas',
        component: 'trigger-flex-event',
    })],

    [triggerNames.CHANGE, new FlexTrigger({
        name: triggerNames.CHANGE,
        label: 'On Change',
        icon: 'caret-square-down',
        iconSet: 'fas',
    })],
]);
